import { Position } from '../../../units/models/position';
import { PositionsActionsUnion, updatePositions, getPositions as getPosition } from '../actions/positions.actions';
import { getPositionsFailure, getPositionsSuccess, PositionsApiActionsUnion, updatePositionsSuccess } from '../actions/positions-api.actions';
import * as UnitSharedActions from '../actions/units-shared.actions';
import { position } from 'polished';


export interface State {
  positions: Position[] | null;
  lastUpdate: Position[];
  areLoading: boolean;
  positionCache: {[key:number]: Position[]};
}

export const initialState: State = {
  positions: [],
  lastUpdate: null,
  areLoading: false,
  positionCache: {}
};

export function reducer(
  state = initialState,
  action: PositionsActionsUnion | PositionsApiActionsUnion | UnitSharedActions.UnitsSharedActionsUnion
): State {
  switch (action.type) {
    case getPositionsSuccess.type: {
      return {
        ...state,
        positions: action.positions,
        areLoading: false
      };
    }
    case getPositionsFailure.type: {
      return {
        ...state,
        positions: null,
        areLoading: false
      };
    }
    case updatePositionsSuccess.type: {
      const positionCache = {...state.positionCache};
      if (action.positions) {
        action.positions.forEach(position => {
          if (positionCache[position.unitId]) {
            const positions = positionCache[position.unitId];
            const lastPosition = positions[positions.length - 1].position;
            if (lastPosition.longitude !== position.position.longitude || lastPosition.latitude !== position.position.latitude) {
              positions.push(position);
            }
            if (positions.length > 10) {
              positions.shift();
            }
          } else {
            positionCache[position.unitId] = [position];
          }
        });
      }
      return {
        ...state,
        positions: action.positions,
        positionCache: positionCache
      };
    }
    case updatePositions.type: {
      return {
        ...state,
        lastUpdate: action.positions
      };
    }
    case getPosition.type: {
      return {
        ...state,
        areLoading: true
      };
    }
    case UnitSharedActions.clearData.type: {
      return {
        ...initialState
      };
    }

    default: {
      return state;
    }
  }
}
export const getPositions = (state: State) => state.positions;
export const getPositionCache = (state: State) => state?.positionCache;
export const getPositionCacheById = (state: State, unitId: number) => state?.positionCache[unitId];
export const getPositionsLastUpdate = (state: State) => state.lastUpdate;
export const arePositionsLoading = (state: State) => state.areLoading;
